export default __webpack_public_path__ + "static/media/045-football.09a12557.svg";